<script setup lang="ts">
/**
 * „Neu seit dem letzten Update": die Karte oben im Inhalt.
 *
 * Bewusst im Fluss, nicht schwebend und kein Dialog. Sie schiebt den Inhalt
 * nach unten, bis jemand sie ausblendet, verdeckt aber nie ein Feld oder einen
 * Knopf und nimmt niemandem den Fokus. Wer gerade einen Text schreibt, liest
 * sie, wenn es passt. So hält es auch miraBOOK.
 *
 * Abstand nach außen gibt die Hülle, die sie einhängt (AppShell, KioskShell):
 * Ist nichts neu, steht hier gar nichts, auch kein leerer Rand.
 *
 * Was angezeigt wird und wann, steht in useNeuerungen.
 */
import { useId } from 'vue'
import { useI18n } from 'vue-i18n'
import { useNeuerungen } from '@/composables/useNeuerungen'

const { t } = useI18n()
const { neu, ausblenden } = useNeuerungen()
const titelId = useId()
</script>

<template>
  <section
    v-if="neu.length"
    :aria-labelledby="titelId"
    class="max-w-3xl rounded-lg border border-line border-l-4 border-l-primary bg-surface px-4 py-3 shadow-sm"
  >
    <div class="flex items-start gap-3">
      <h2 :id="titelId" class="flex-1 pt-0.5 text-sm font-semibold text-fg">
        {{ t('changelog.title') }}
      </h2>
      <button
        type="button"
        class="shrink-0 rounded-md px-2 py-1 text-xs font-medium text-fg-mid transition-colors hover:bg-hover hover:text-fg"
        @click="ausblenden"
      >
        {{ t('changelog.dismiss') }}
      </button>
    </div>
    <ul class="mt-1.5 grid list-disc gap-1 pl-5 text-sm text-fg-mid">
      <li v-for="e in neu" :key="e.id">{{ t(e.schluessel) }}</li>
    </ul>
  </section>
</template>
